import React from 'react';
import {
  Dimensions,
  Modal,
  StyleSheet,
  TouchableOpacity,
  Text,
  View,
} from 'react-native';
import {Color, globalFontStyle, globalStyle} from '../../../assets';
import Width from '../../../assets/Width';
import CustomButton from '../../../commonComponents/CustomButton';
import LottieComp from '../../../commonComponents/Lottie';
import {
  no_order_executed,
  no_order_placed,
  order_failed,
  txn_success,
  yes_order_executed,
  yes_order_placed,
} from '../../../utils/images';
import ClubSettlementResponse from './ClubSettlementResponse';
import Colors from '../../../assets/Color/Colors';
import {globalConst} from "../../../utils/globalConstant";

const Error = ({orderData, onDoneClick}) => {
  return (
    <View style={{flex: 1}}>
      <LottieComp width={200} height={200} lottieJson={order_failed} />
      <Text style={[styles.orderStatusText, {color: Color.red}]}>
        {' '}
        {orderData?.error}
      </Text>
      <Text style={[styles.failedOrderText]}>{orderData?.message}</Text>

      <View style={[globalStyle.customBtnParentModalStyle]}>
        <CustomButton
          btnText={'Retry'}
          btnType={'normalBlue'}
          onBtnClick={onDoneClick}
        />
      </View>
    </View>
  );
};

const ClubOrderStatus = ({
  clubOrderResponse,
  onDoneClick,
  settleOrderHandler,
}) => {
  let successRes = clubOrderResponse?.success;
  let successVar;
  if (successRes) {
    successVar = clubOrderResponse?.data;
  }
  let isSettlement = clubOrderResponse?.isSettlement;
  if (isSettlement) {
    return (
      <ClubSettlementResponse
        onDoneClick={()=>{
          setTimeout(() => {
            settleOrderHandler();
          }, globalConst?.buttonTimer);
        }}
        clubOrderResponse={clubOrderResponse}
      />
    );
  }

  let responseObj = [];
  if (successRes) {
    responseObj = [
      {
        title: 'Invested Amount',
        val: successVar?.investment.toFixed(2),
      },
      {
        title: 'Potential Returns',
        val: successVar?.returns?.toFixed(2),
      },
    ];
  }

  return (
    <View style={{flex: 1}}>
      <View
        style={{
          width: Width.width - 30,
          flex: 1,
        }}>
        {!successRes ? (
          <Error onDoneClick={onDoneClick} orderData={clubOrderResponse} />
        ) : (
          <>
            <LottieComp
              width={200}
              height={200}
              lottieJson={yes_order_executed}
            />
            <Text style={[styles.orderStatusText, {color: Colors.tradexBlue}]}>
              Order Executed
            </Text>

            <View style={styles.tableContainer}>
              {responseObj.map((item, index) => {
                return (
                  <View key={index} style={styles.tableRow}>
                    <Text style={styles.textFontStyle}>{item.title}</Text>
                    <Text style={styles.textFontStyle}> &#8377;{item.val}</Text>
                  </View>
                );
              })}
            </View>

            <View style={[globalStyle.customBtnParentModalStyle]}>
              <CustomButton
                btnText="Done"
                btnType={'normalBlue'}
                onBtnClick={onDoneClick}
              />
            </View>
          </>
        )}
      </View>
    </View>
  );
};

export default ClubOrderStatus;

const styles = StyleSheet.create({
  orderStatusText: {
    ...globalFontStyle.appFontTitle,
    alignSelf: 'center',
    marginBottom: 20,
  },
  textFontStyle: {
    ...globalFontStyle.appFontSubText,
    color: Color.black,
  },
  tableRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 13,
  },
  tableContainer: {
    borderWidth: 0.5,
    borderColor: 'rgba(0, 0, 0, 0.5)',
    borderRadius: 3,
    paddingHorizontal: 18,
    paddingVertical: 15,
  },
  failedOrderText: {
    ...globalFontStyle.appFontBody,
    color: Color.lightgrey,

    textAlign: 'center',
  },
});
